export const environment = {
  production: false,
  appUrl: 'https://plataforma-regulare.netlify.app',
  firebase: {
      apiKey: "AIzaSyCZu4Cr3Dg5kuBm8c9aEa4jDnSWaI71i3A",
    authDomain: "regulare-compliance.firebaseapp.com",
    projectId: "regulare-compliance",
    storageBucket: "regulare-compliance.firebasestorage.app",
    messagingSenderId: "735146497420",
    appId: "1:735146497420:web:7cf0a56ac968e121b1b2a9",
   measurementId: "G-56D1C5EJHD"
  }
} as const;